/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react";
import { Helmet } from "react-helmet";
import { decode } from "html-entities";

function SEO({ meta, openGraph, title, calonical }) {
  return (
    <Helmet>
      <title>{decode(title)}</title>
      {Object.keys(meta).map((v) => (
        <meta name={v} content={decode(meta[v])} key={v} />
      ))}

      {Object.keys(openGraph).map((v) => (
        <meta property={v} content={decode(openGraph[v])} key={v} />
      ))}
      {!!calonical && <link rel="calonical" href={calonical} key="calonical" />}
    </Helmet>
  );
}

export default SEO;
